module.exports = __webpack_public_path__ + "img/physics-big.bfab0697.jpg";